// The one icon set of both apps: 24px outline icons (Lucide's geometry), drawn with the text colour.
import { type ReactNode } from 'react';

const line = (d: string) => <path d={d} />;

const ICONS = {
  dashboard: (
    <>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </>
  ),
  home: (
    <>
      {line('M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8')}
      {line(
        'M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
      )}
    </>
  ),
  card: (
    <>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      {line('M2 10h20')}
    </>
  ),
  people: (
    <>
      {line('M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2')}
      <circle cx="9" cy="7" r="4" />
      {line('M22 21v-2a4 4 0 0 0-3-3.87')}
      {line('M16 3.13a4 4 0 0 1 0 7.75')}
    </>
  ),
  person: (
    <>
      {line('M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2')}
      <circle cx="12" cy="7" r="4" />
    </>
  ),
  transfer: (
    <>
      {line('M8 3 4 7l4 4')}
      {line('M4 7h16')}
      {line('m16 21 4-4-4-4')}
      {line('M20 17H4')}
    </>
  ),
  coins: (
    <>
      <circle cx="8" cy="8" r="6" />
      {line('M18.09 10.37A6 6 0 1 1 10.34 18')}
      {line('M7 6h1v4')}
      {line('m16.71 13.88.7.71-2.82 2.82')}
    </>
  ),
  briefcase: (
    <>
      <rect x="2" y="7" width="20" height="14" rx="2" />
      {line('M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16')}
    </>
  ),
  document: (
    <>
      {line('M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z')}
      {line('M14 2v4a2 2 0 0 0 2 2h4')}
      {line('M10 9H8')}
      {line('M16 13H8')}
      {line('M16 17H8')}
    </>
  ),
  server: (
    <>
      <rect x="2" y="2" width="20" height="8" rx="2" />
      <rect x="2" y="14" width="20" height="8" rx="2" />
      {line('M6 6h.01')}
      {line('M6 18h.01')}
    </>
  ),
  bank: (
    <>
      {line('M3 22h18')}
      {line('M6 18v-7')}
      {line('M10 18v-7')}
      {line('M14 18v-7')}
      {line('M18 18v-7')}
      {line('m12 2 8 5H4z')}
    </>
  ),
  monitor: (
    <>
      <rect x="2" y="3" width="20" height="14" rx="2" />
      {line('M8 21h8')}
      {line('M12 17v4')}
    </>
  ),
  sliders: (
    <>
      {line('M21 4h-7')}
      {line('M10 4H3')}
      {line('M21 12h-9')}
      {line('M8 12H3')}
      {line('M21 20h-5')}
      {line('M12 20H3')}
      {line('M14 2v4')}
      {line('M8 10v4')}
      {line('M16 18v4')}
    </>
  ),
  support: (
    <>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      {line('m4.93 4.93 4.24 4.24')}
      {line('m14.83 9.17 4.24-4.24')}
      {line('m14.83 14.83 4.24 4.24')}
      {line('m9.17 14.83-4.24 4.24')}
    </>
  ),
  shield: line(
    'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z',
  ),
  lock: (
    <>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      {line('M7 11V7a5 5 0 0 1 10 0v4')}
    </>
  ),
  signOut: (
    <>
      {line('M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4')}
      {line('m16 17 5-5-5-5')}
      {line('M21 12H9')}
    </>
  ),
  menu: line('M4 6h16M4 12h16M4 18h16'),
  close: line('M18 6 6 18M6 6l12 12'),
  plus: line('M5 12h14M12 5v14'),
  upload: (
    <>
      {line('M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4')}
      {line('m17 8-5-5-5 5')}
      {line('M12 3v12')}
    </>
  ),
  refresh: (
    <>
      {line('M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8')}
      {line('M21 3v5h-5')}
      {line('M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16')}
      {line('M8 16H3v5')}
    </>
  ),
  chevronRight: line('m9 18 6-6-6-6'),
  arrowUp: line('m5 12 7-7 7 7M12 19V5'),
  arrowDown: line('M12 5v14M19 12l-7 7-7-7'),
} satisfies Record<string, ReactNode>;

export type IconName = keyof typeof ICONS;

/** Decorative beside its label: hidden from screen readers. */
export function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg
      className="ui-icon"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICONS[name]}
    </svg>
  );
}
